import { createCharacter } from './builder';
import { createAttackAnimation, createIdleAnimation, createRunAnimation } from './animations';
import { createMeleeHorizontalAttack } from './attacks';
import { RUN_SPEED } from './constants';
import { createBasicLifecycleScript } from '../lifecycle';

export const ZOMBIE_CONFIG = createCharacter({
  id: 'lavazombie',
  name: 'Lava Zombie',
  assetPath: '/assets/characters/zombie/Zombie Idle blender.glb',
  health: {
    max: 10,
  },
  scale: 1.0,
  modelAxes: {
    forward: { x: 0, y: 0, z: -1 },
    up: { x: 0, y: 1, z: 0 }
  },
  moveSpeed: RUN_SPEED * 0.25,
  physics: {
    jumpHeight: 1.0
  },
  collidesWithCharacters: false,
  turnMode: 'interpolate',
  animations: {
    idle: createIdleAnimation('/assets/characters/zombie/Zombie Idle.glb'),
    run: createRunAnimation('/assets/characters/zombie/Zombie Running.glb', {
      applyRootMotion: false,
        speed:1
    }),
    walk: createRunAnimation('/assets/characters/zombie/Zombie Walk.glb', {
      applyRootMotion: false,
        speed: 1
    }),
    attack: createAttackAnimation('/assets/characters/zombie/Zombie Attack.glb', {
      applyRootMotion: true
    }),
    hit_react: createIdleAnimation('/assets/characters/zombie/Zombie Reaction Hit.glb', {
      speed: 2,
      applyRootMotion: true
    }),
    death: createIdleAnimation('/assets/characters/zombie/Zombie Death.glb', {
      speed: 1,
      applyRootMotion: true
    })
  },
  transitions: [
    { from: 'idle', to: 'run', duration: 0.3 },
    { from: 'run', to: 'idle', duration: 0.2 },
    { from: 'idle', to: 'walk', duration: 0.3 },
    { from: 'walk', to: 'idle', duration: 0.2 },
    { from: 'walk', to: 'run', duration: 0.2 },
    { from: 'run', to: 'walk', duration: 0.2 }
  ],
  lifecycle: createBasicLifecycleScript({
    id: 'zombie-default-lifecycle',
    hitAnimation: 'hit_react',
    deathAnimation: 'death',
    despawnMode: 'after-animation'
  }),
  combatBindings: {
    action: 'zombie_attack'
  },
  combatAttacks: {
    zombie_attack: createMeleeHorizontalAttack({
      id: 'zombie_attack',
      animation: 'attack',
      damage: 10,
      cooldown: 1.5,
      weaponConfig: {
        meleeRange: 2.0
      },
      events: [
        { time: 0.0, type: 'attachWeapon', params: { bone: 'mixamorig:RightHand' } },
        { time: 0.3, type: 'enableHitbox' },
        { time: 0.6, type: 'disableHitbox' }
      ]
    })
  }
});
